// src/store/commonCode/commonCode.selectors.ts
import type {
  PageContent,
  CommonGroupItem,
  CommonCodeItem,
} from "src/types/common/commonCodeTypes";

const EMPTY_GROUPS: CommonGroupItem[] = [];
const EMPTY_CODES: CommonCodeItem[] = [];

export const selectCommonLoading = (s: any) => s.loading as boolean;
export const selectCommonError = (s: any) => s.error as string | null;

// groups
export const selectGroupQuery = (s: any) => s.groupQuery;
export const selectGroupPage = (s: any) => s.groupPage as PageContent<CommonGroupItem> | null;
export const selectGroupList = (s: any) =>
  s.groupPage?.content ? (s.groupPage.content as CommonGroupItem[]) : EMPTY_GROUPS;
export const selectGroupTotalPages = (s: any) => s.groupPage?.totalPages ?? 1;
export const selectGroupTotalElements = (s: any) => s.groupPage?.totalElements ?? 0;

// codes
export const selectSelectedGrpCode = (s: any) => s.selectedGrpCode as string;
export const selectCodeQuery = (s: any) => s.codeQuery;
export const selectCodePage = (s: any) => s.codePage as PageContent<CommonCodeItem> | null;
export const selectCodeList = (s: any) =>
  s.codePage?.content ? (s.codePage.content as CommonCodeItem[]) : EMPTY_CODES;
export const selectCodeTotalPages = (s: any) => s.codePage?.totalPages ?? 1;
export const selectCodeTotalElements = (s: any) => s.codePage?.totalElements ?? 0;
